import { engineConfig } from '@/Constants/3dConfig';
import { getIntersection } from '@/Engine/intersections';
import { $ } from '@/Engine/stateInstance';
import { sides } from '@/Interfaces/common';
import { Line3, Quaternion } from 'three';
import { addBoxHelpers, removeBoxHelpers } from '@/Engine/addBoxHelper';
import { useUIOnlyStore } from '@/Store/storeUI';
import { onShelfMoving } from '@/Engine/eventHandlers/onShelfMoving';
import { onPointerMoveToAnotherWall } from '@/Engine/eventHandlers/onPointerMoveToAnotherWall';
import { onCtrlKeyMoving } from '@/Engine/eventHandlers/onCtrlKeyMoving';
import { detachShelf } from '@/Engine/eventHandlers/lib/attachShelf';
import { Shelf } from '@/Engine/Wardrobe/Shelf';
import { detachRack } from '@/Engine/eventHandlers/lib/attachRack';

export const onObjectMoveMode = () => {
    useUIOnlyStore().setElementInfoActive(false);

    const floorIntersection = getIntersection([ $.room.floorRaycastPlane ]);
    if (floorIntersection[0] && $.selectionBoxForBox.target) {

        const newFloorPoint = floorIntersection[0].point.clone();
        if (!$.floorPointer) {
            $.floorPointer = newFloorPoint;
        }
        const line = new Line3(
            $.floorPointer.clone(),
            newFloorPoint.clone(),
        );
        $.selectionBoxForBox.setPositionDelta(line);
        // $.render();
        return;
    }

    const wallIntersections = getIntersection($.room.raycastPlanes);
    const newShelfIndex = null;
    if (!wallIntersections[0]) return;

    if (!$.selectionBox.side)
        $.selectionBox.side = wallIntersections[0].object.name as sides;
    // Точка на стене
    const newWallPointer = wallIntersections[0].point.clone();
    if ($.wallPointer) {
        const line = new Line3(
            $.wallPointer.clone(),
            newWallPointer.clone(),
        );

        // Проверяем что это та же стена
        if ($.wallPointer && $.selectionBox.side === wallIntersections[0].object.name) {
            $.moved = true;
            // Если выделен один объект
            if ($.selectionBox.target) {
                const localLine = new Line3(
                    $.selectionBox.target.rotate(line.start),
                    $.selectionBox.target.rotate(line.end),
                );
                const shiftedDelta = $.selectionBox.target.position.clone().sub(localLine.start);
                // TODO не получается использовать shiftedLocalLine;
                const shiftedLocalLine = new Line3(
                    localLine.start.add(shiftedDelta),
                    localLine.end.add(shiftedDelta),
                );
                const quaternion = new Quaternion();
                $.selectionBox.target.model.getWorldQuaternion(quaternion);
                const delta = $.selectionBox.target.position
                    .clone()
                    .applyQuaternion(quaternion)
                    .sub(localLine.start);
                const shiftedLine = new Line3(
                    localLine.start.add(delta),
                    localLine.end.add(delta),
                );

                // Если зажат ctrl
                if ($.ctrlKey) {
                    onCtrlKeyMoving($.selectionBox.target);
                }

                // Если полка или панель
                if ([ 'shelf', 'panel' ].includes($.selectionBox.target.type)) {
                    if (onShelfMoving(line, localLine)) {
                        $.wallPointer = newWallPointer.clone();
                        return;
                    }
                } else if ([ 'rackModule' ].includes($.selectionBox.target.type)) {
                    // TODO работает по приращениям
                    const success = $.selectionBox.setPositionDelta(line);
                    if (success) {
                        $.wallPointer = newWallPointer.clone();
                        return;
                    }
                }
                // Окна, двери
                else {
                    const success = $.selectionBox.setPositionDelta(line);
                    if (success) {
                        // Меняем позицию шаблона окна и двери пока они не созданы в сторе
                        if ($.tempWindowData) {
                            $.tempWindowData.position = $.selectionBox.target.position.toArray();
                            $.tempWindowData.side = $.selectionBox.side;
                        }
                        if ($.tempDoorData) {
                            $.tempDoorData.position =  $.selectionBox.target.position.toArray();
                            $.tempDoorData.side = $.selectionBox.side;
                        }

                        $.wallPointer = newWallPointer.clone();
                        return;
                    }
                    return;
                }
                return;
            }

            // Если выделена группа
            if ($.selectionBox.targetGroup.length) {
                if (!$.selectionBox.setGroupPositionDelta(line)) return;
            }
            // Вспомогательная геометрия, по дефолту отключена, включается в 3dConfig.js
            if (engineConfig.boxHelper) {
                removeBoxHelpers();
                addBoxHelpers([ ...$.wardrobe.rackModules, ...$.windows, ...$.doors ]);
            }
        } else if ($.selectionBox.side !== wallIntersections[0].object.name) {
            if ($.selectionBox.target) {
                if ([ 'shelf', 'panel' ].includes($.selectionBox.target.type)) {
                    $.bigDistanceFlag = true;

                    if ($.selectionBox.target?.rackModule?.shelves.length > 1) {
                        detachShelf($.selectionBox.target);
                    }
                    if ($.selectionBox.target.rackModule.railGroup.racks.length > 1) {
                        detachRack($.selectionBox.target);
                    }
                }
            }
            // TODO до перехода надо отстыковать полку
            // Переход на другую стену.
            const side = wallIntersections[0].object.name as sides;
            onPointerMoveToAnotherWall(side, line) ;
        }
    }

    $.shelfPlace = newShelfIndex ?? null;
    $.wallPointer = newWallPointer.clone();
};
